module.exports = __webpack_public_path__ + "static/media/delete.277c2ea0.svg";